import { Copy } from '../copy/Copy';

export const awardMapper = (theme, userData) => [
  {
    color: theme.palette.neons.pink,
    text: Copy.generate('Achievements.awards.firstActivity'),
    isActive: userData?.activities.length > 0,
  },
  {
    color: theme.palette.neons.blue,
    text: Copy.inject('Achievements.awards.contributed', {
      miles: 10,
    }),
    isActive: userData?.totalDistance >= 10,
  },
  {
    color: theme.palette.neons.green,
    text: Copy.inject('Achievements.awards.contributed', {
      miles: 20,
    }),
    isActive: userData?.totalDistance >= 20,
  },
  {
    color: theme.palette.neons.yellow,
    text: Copy.inject('Achievements.awards.contributed', {
      miles: 50,
    }),
    isActive: userData?.totalDistance >= 50,
  },
  {
    color: theme.palette.neons.orange,
    text: Copy.inject('Achievements.awards.contributed', {
      miles: 100,
    }),
    isActive: userData?.totalDistance >= 100,
  },
  {
    color: theme.palette.neons.purple,
    text: Copy.inject('Achievements.awards.contributed', {
      miles: 200,
    }),
    isActive: userData?.totalDistance >= 200,
  },
  {
    color: theme.palette.neons.red,
    text: Copy.inject('Achievements.awards.contributed', {
      miles: 300,
    }),
    isActive: userData?.totalDistance >= 300,
  },
  {
    color: theme.palette.neons.pink,
    text: Copy.inject('Achievements.awards.walking', {
      miles: 10,
    }),
    isActive: userData?.totalWalking >= 10,
  },
  {
    color: theme.palette.neons.blue,
    text: Copy.inject('Achievements.awards.running', {
      miles: 10,
    }),
    isActive: userData?.totalRunning >= 10,
  },
  {
    color: theme.palette.neons.green,
    text: Copy.inject('Achievements.awards.cycling', {
      miles: 10,
    }),
    isActive: userData?.totalCycling >= 10,
  },
  {
    color: theme.palette.neons.yellow,
    text: Copy.inject('Achievements.awards.swimming', {
      miles: 1,
    }),
    isActive: userData?.totalSwimming >= 1,
  },
  {
    color: theme.palette.neons.orange,
    text: Copy.inject('Achievements.awards.walking', {
      miles: 20,
    }),
    isActive: userData?.totalWalking >= 20,
  },
  {
    color: theme.palette.neons.purple,
    text: Copy.inject('Achievements.awards.running', {
      miles: 20,
    }),
    isActive: userData?.totalRunning >= 20,
  },
  {
    color: theme.palette.neons.red,
    text: Copy.inject('Achievements.awards.cycling', {
      miles: 20,
    }),
    isActive: userData?.totalCycling >= 20,
  },
  {
    color: theme.palette.neons.pink,
    text: Copy.inject('Achievements.awards.swimming', {
      miles: 5,
    }),
    isActive: userData?.totalSwimming >= 5,
  },
  {
    color: theme.palette.neons.blue,
    text: Copy.inject('Achievements.awards.walking', {
      miles: 50,
    }),
    isActive: userData?.totalWalking >= 50,
  },
  {
    color: theme.palette.neons.green,
    text: Copy.inject('Achievements.awards.running', {
      miles: 50,
    }),
    isActive: userData?.totalRunning >= 50,
  },
  {
    color: theme.palette.neons.yellow,
    text: Copy.inject('Achievements.awards.cycling', {
      miles: 50,
    }),
    isActive: userData?.totalCycling >= 50,
  },
  {
    color: theme.palette.neons.orange,
    text: Copy.inject('Achievements.awards.swimming', {
      miles: 10,
    }),
    isActive: userData?.totalSwimming >= 10,
  },
  {
    color: theme.palette.neons.purple,
    text: Copy.inject('Achievements.awards.cycling', {
      miles: 100,
    }),
    isActive: userData?.totalCycling >= 100,
  },
  {
    color: theme.palette.neons.red,
    text: Copy.inject('Achievements.awards.cycling', {
      miles: 200,
    }),
    isActive: userData?.totalCycling >= 200,
  },
];
